import React from 'react';
import { Rating } from '@material-ui/lab';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import parse from 'html-react-parser';

const ReviewTable = (props) => {

    function truncateReview(str)
	{
		let limit = 35;
		if(str != null) {
			return str.length > limit ? str.substring(0, limit) + "..." : str;
		} else {
			return "Review N/A";
		}
	}

    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th className="text-left">Author</th>
                    <th className="text-left">Review</th>
                    <th className="text-center">Rating</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-left">
                        {props.review.user.first_name}&nbsp;{props.review.user.last_name}
                    </td>
                    <td className="text-left">
                        {truncateReview(parse(props.review.comment))}
                    </td>
                    <td>
                        <Rating 
                            size="small" 
                            precision={0.5} 
                            value={parseFloat(props.review.rating)} 
                            readOnly
                            emptyIcon={
                                <StarBorderIcon fontSize="inherit" color="disabled" />
                            } 
                        />
                    </td>
                </tr>
            </tbody>
        </table> 
    );
};

export default ReviewTable;